var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderTracking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.811,
    height: 19.993,
    viewBox: "0 0 31.811 19.993",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18918",
    "data-name": "Group 18918",
    transform: "translate(-1477.5 -607)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "truck",
    d: "M0,4.5A2.58,2.58,0,0,1,2.654,2H18.579a2.58,2.58,0,0,1,2.654,2.5V7h1.8a2.719,2.719,0,0,1,2.07.938l2.621,3.081a2.408,2.408,0,0,1,.582,1.562v3.579a2.58,2.58,0,0,1-2.654,2.5h-.885a3.545,3.545,0,0,1-7.078,0H8.847a3.3,3.3,0,0,1-1.811,2.914A3.73,3.73,0,0,1,3.451,21.5a3.283,3.283,0,0,1-1.678-2.984A2.513,2.513,0,0,1,0,16.156ZM2.29,16.916a3.6,3.6,0,0,1,3.064-1.592,3.582,3.582,0,0,1,3.019,1.665h9.8a3.442,3.442,0,0,1,1.3-1.219V4.5a.86.86,0,0,0-.885-.833H2.654a.86.86,0,0,0-.885.833V16.156a.832.832,0,0,0,.52.759m18.943-1.592A3.585,3.585,0,0,1,24.3,16.989h1.359a.86.86,0,0,0,.885-.833V12.576a.8.8,0,0,0-.195-.52L23.728,8.975a.906.906,0,0,0-.69-.313h-1.8ZM5.308,16.989a1.669,1.669,0,1,0,0,3.331,1.669,1.669,0,1,0,0-3.331m15.925,0A1.669,1.669,0,1,0,23,18.655a1.72,1.72,0,0,0-1.769-1.665",
    transform: "translate(1481 605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_198",
    "data-name": "Line 198",
    x2: 5,
    transform: "translate(1479.5 613.662)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_199",
    "data-name": "Line 199",
    x2: 5,
    transform: "translate(1478.5 616.993)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderTracking);
export default __webpack_public_path__ + "static/media/orderTracking.84ff84e6258acede49bc3e7af25726d0.svg";
export { ForwardRef as ReactComponent };